import React from 'react';
import PropTypes from 'prop-types';
// Utils
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import sidebarMenuEntries from '../../../constants/sidebarMenuEntries';
import cn from '../../../utils/cn';
// Icons
import { ReactComponent as ChevronDownIcon } from '../../../assets/icons/chevron_down.svg';
import { ReactComponent as LogoutIcon } from '../../../assets/icons/logout.svg';
// Components
import styles from './Sidebar.module.scss';
import Button from '../../atoms/Button/Button';

function Sidebar({ parentStyles }) {
  const { t } = useTranslation();
  const location = useLocation();

  const isActivePage = (entry) => {
    if (entry?.subLevels) {
      return entry.subLevels?.some((level) => level.path === location.pathname);
    }
    return entry.path === location.pathname;
  };

  return (
    <section className={cn([styles.sidebar, 'd-flex d-col a-stretch'])}>
      <div className="p-t-20 p-b-20 laptop-p-b-0">
        {sidebarMenuEntries.map((entry, index) => (
          <React.Fragment key={index}>
            {entry.subLevels ? (
              <div className={styles.sublevels}>
                <div
                  className={cn([
                    styles.menu_link,
                    'd-flex a-center font-secondary fw-400',
                    isActivePage(entry) ? styles.active : '',
                  ])}
                >
                  {entry.icon}
                  <span className={cn(['m-l-10', parentStyles.hidden_on_fold])}>{t(entry.label)}</span>

                  <ChevronDownIcon
                    className={cn(['m-l-auto', styles.chevron_icon, parentStyles.hidden_on_fold])}
                    width={15}
                    height={15}
                  />
                </div>

                <div className={styles.sublevels_panel}>
                  {entry.subLevels.map((level, ind) => (
                    <a
                      key={ind}
                      href={level.path}
                      className={cn([styles.sublevels_link, 'd-flex a-center fw-400'])}
                    >
                      <span className="m-l-10">{t(level.label)}</span>
                    </a>
                  ))}
                </div>
              </div>
            ) : (
              <a
                href={entry.path}
                className={cn([
                  styles.menu_link,
                  'd-flex a-center fw-400',
                  isActivePage(entry) ? styles.active : ''])}
              >
                {entry.icon}
                <span className={cn(['m-l-10', parentStyles.hidden_on_fold])}>{t(entry.label)}</span>
              </a>
            )}
          </React.Fragment>
        ))}
      </div>

      <div className={cn([styles.logout, parentStyles.hidden_on_fold])}>
        <a href="/logout">
          <Button theme="white" full>
            <LogoutIcon width={18} height={18} className="m-r-10" />
            {t('login.logout')}
          </Button>
        </a>
      </div>
    </section>
  );
}

Sidebar.propTypes = {
  parentStyles: PropTypes.shape({
    hidden_on_fold: PropTypes.string,
  }).isRequired,
};

export default Sidebar;
